import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, vShow as _vShow, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card card-default custom-card-height" }
const _hoisted_3 = { class: "card-header feature-header" }
const _hoisted_4 = { class: "row g-2" }
const _hoisted_5 = { class: "col-auto me-auto" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = { class: "card-body card-body-custom-layout" }
const _hoisted_9 = { class: "card-body-grid" }
const _hoisted_10 = { class: "actions-row" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  class: "modal fade",
  id: "PageModal",
  Page: "dialog"
}
const _hoisted_13 = { class: "modal-dialog modal-lg" }
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = { class: "modal-header" }
const _hoisted_16 = { class: "modal-title" }
const _hoisted_17 = { class: "modal-body" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-6 form-group" }
const _hoisted_20 = { class: "form-label" }
const _hoisted_21 = { class: "col-md-6 form-group" }
const _hoisted_22 = { class: "form-label" }
const _hoisted_23 = { class: "password-input-wrapper" }
const _hoisted_24 = ["type"]
const _hoisted_25 = { class: "col-md-6 mt-2 form-group" }
const _hoisted_26 = { class: "form-label" }
const _hoisted_27 = { class: "password-input-wrapper" }
const _hoisted_28 = ["type"]
const _hoisted_29 = { class: "col-md-6 mt-2 form-group" }
const _hoisted_30 = { class: "form-label" }
const _hoisted_31 = { class: "password-input-wrapper" }
const _hoisted_32 = ["type"]
const _hoisted_33 = { class: "col-md-6 form-group" }
const _hoisted_34 = { class: "icheck-success" }
const _hoisted_35 = {
  class: "form-label",
  for: "shouldSync"
}
const _hoisted_36 = { class: "modal-footer" }
const _hoisted_37 = {
  type: "submit",
  class: "btn btn-sm btn-outline-info-reverse"
}
const _hoisted_38 = {
  class: "modal fade",
  id: "force-sync-modal",
  role: "dialog"
}
const _hoisted_39 = { class: "modal-dialog modal-md" }
const _hoisted_40 = { class: "modal-content" }
const _hoisted_41 = { class: "modal-header" }
const _hoisted_42 = { class: "modal-body" }
const _hoisted_43 = { class: "form-row" }
const _hoisted_44 = { class: "form-check" }
const _hoisted_45 = { class: "form-row" }
const _hoisted_46 = { class: "form-check" }
const _hoisted_47 = { class: "modal-body" }
const _hoisted_48 = { class: "form-row" }
const _hoisted_49 = { class: "col" }
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = { class: "modal-footer" }
const _hoisted_52 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTitleComponent = _resolveComponent("CardTitleComponent")!
  const _component_SearchComponent = _resolveComponent("SearchComponent")!
  const _component_e_column = _resolveComponent("e-column")!
  const _component_e_columns = _resolveComponent("e-columns")!
  const _component_ejs_grid = _resolveComponent("ejs-grid")!
  const _component_ejs_dropdownlist = _resolveComponent("ejs-dropdownlist")!
  const _component_DatePickerComponent = _resolveComponent("DatePickerComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_CardTitleComponent)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_SearchComponent, {
                modelValue: _ctx.searchText,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                onSearch: _ctx.onSearch,
                onClear: _ctx.clearSearch
              }, null, 8, ["modelValue", "onSearch", "onClear"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                class: "btn btn-outline-primary btn-sm",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal()))
              }, [
                _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fas fa-plus" }, null, -1)),
                _createTextVNode("  " + _toDisplayString(_ctx.$t("addNew")), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_ejs_grid, {
              ref: "companyGrid",
              dataSource: _ctx.gridData,
              allowPaging: true,
              allowResizing: true,
              allowScrolling: true,
              pageSettings: _ctx.pageSettings,
              locale: _ctx.locale,
              rowHeight: 30,
              height: "100%",
              allowSorting: true,
              searchSettings: _ctx.searchOptions,
              commandClick: _ctx.commandClick
            }, {
              columnTemplate: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(
                        data.shouldSync
                          ? 'badge text-bg-success'
                          : 'badge text-bg-danger'
                      )
                }, _toDisplayString(data.shouldSync ? _ctx.$t("active") : _ctx.$t("inactive")), 3)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_e_columns, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('Legal Entity'),
                      field: "legalEntityName",
                      width: "150",
                      freeze: "Left"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      field: "id",
                      visible: false
                    }),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('applicationKey'),
                      field: "applicationKey",
                      valueAccessor: (record) => { return '*******' ; }
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('clientKey'),
                      field: "clientKey",
                      valueAccessor: (record) => { return '*******' ; }
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('subscriptionKey'),
                      field: "subscriptionKey",
                      valueAccessor: (record) => { return '*******' ; }
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      field: "shouldSync",
                      headerText: _ctx.$t('enableSyncing'),
                      template: 'columnTemplate',
                      width: "150"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('actions'),
                      textAlign: "Center",
                      template: 'actionTemplate',
                      freeze: "Right",
                      width: "100"
                    }, {
                      actionTemplate: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "ms-2 action-link action-edit",
                            title: "Edit",
                            onClick: ($event: any) => (_ctx.commandClick({ commandColumn: { type: 'Edit' }, rowData: data }))
                          }, [...(_cache[20] || (_cache[20] = [
                            _createElementVNode("i", { class: "e-edit e-icons" }, null, -1)
                          ]))], 8, _hoisted_11)
                        ])
                      ]),
                      _: 1
                    }, 8, ["headerText"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["dataSource", "pageSettings", "locale", "searchSettings", "commandClick"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.$t("company")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal()))
            }, [...(_cache[21] || (_cache[21] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.upsertCompany && _ctx.upsertCompany(...args)))
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, [
                    _createTextVNode(_toDisplayString(_ctx.$t("legalEntity")) + " ", 1),
                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                  ]),
                  _createVNode(_component_ejs_dropdownlist, {
                    id: "legalEntityDropDown",
                    ref: "legalEntityDropDown",
                    dataSource: _ctx.legalEntityOptions,
                    fields: { text: 'name', value: 'id' },
                    modelValue: _ctx.form.legalEntityId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.legalEntityId) = $event)),
                    placeholder: _ctx.$t('legalEntity'),
                    popupWidth: "auto",
                    showClearButton: true
                  }, null, 8, ["dataSource", "modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, [
                    _createTextVNode(_toDisplayString(_ctx.$t("applicationKey")) + " ", 1),
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.showApplicationKey ? 'text' : 'password',
                      class: "form-control input-sm password-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.applicationKey) = $event)),
                      required: ""
                    }, null, 8, _hoisted_24), [
                      [_vModelDynamic, _ctx.form.applicationKey]
                    ]),
                    _createElementVNode("i", {
                      class: _normalizeClass([_ctx.showApplicationKey ? 'fas fa-eye-slash' : 'fas fa-eye', "toggle-icon password-toggle-btn"]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showApplicationKey = !_ctx.showApplicationKey))
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, [
                    _createTextVNode(_toDisplayString(_ctx.$t("clientKey")) + " ", 1),
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.showClientKey ? 'text' : 'password',
                      class: "form-control input-sm password-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.clientKey) = $event)),
                      required: ""
                    }, null, 8, _hoisted_28), [
                      [_vModelDynamic, _ctx.form.clientKey]
                    ]),
                    _createElementVNode("i", {
                      class: _normalizeClass([_ctx.showClientKey ? 'fas fa-eye-slash' : 'fas fa-eye', "toggle-icon password-toggle-btn"]),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showClientKey = !_ctx.showClientKey))
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, [
                    _createTextVNode(_toDisplayString(_ctx.$t("subscriptionKey")) + " ", 1),
                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.showSubscriptionKey ? 'text' : 'password',
                      class: "form-control input-sm password-input",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.subscriptionKey) = $event)),
                      required: ""
                    }, null, 8, _hoisted_32), [
                      [_vModelDynamic, _ctx.form.subscriptionKey]
                    ]),
                    _createElementVNode("i", {
                      class: _normalizeClass([_ctx.showSubscriptionKey ? 'fas fa-eye-slash' : 'fas fa-eye', "toggle-icon password-toggle-btn"]),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showSubscriptionKey = !_ctx.showSubscriptionKey))
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input me-1",
                      id: "shouldSync",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.shouldSync) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.shouldSync]
                    ]),
                    _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("enableSyncing")), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-close",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.closeModal()))
              }, [
                _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fas fa-times" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("close")), 1)
              ]),
              _createElementVNode("button", _hoisted_37, [
                _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fas fa-save" }, null, -1)),
                _createTextVNode("  " + _toDisplayString(_ctx.isUpdate ? _ctx.$t("update") : _ctx.$t("save")), 1)
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _cache[29] || (_cache[29] = _createElementVNode("h4", { class: "modal-title" }, "Request Sync", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeForceSyncModal && _ctx.closeForceSyncModal(...args)))
            }, [...(_cache[28] || (_cache[28] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.forceSync.type) = $event)),
                  value: "full",
                  id: "syncRadio1"
                }, null, 512), [
                  [_vModelRadio, _ctx.forceSync.type]
                ]),
                _cache[30] || (_cache[30] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "syncRadio1"
                }, " Full Sync ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.forceSync.type) = $event)),
                  value: "custom",
                  id: "syncRadio2"
                }, null, 512), [
                  [_vModelRadio, _ctx.forceSync.type]
                ]),
                _cache[31] || (_cache[31] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "syncRadio2"
                }, " Custom Sync ", -1))
              ])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", null, [
                    _createTextVNode("Date: "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_DatePickerComponent, {
                    modelValue: _ctx.forceSync.date,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.forceSync.date) = $event)),
                    format: _ctx.forceSync.format,
                    max: _ctx.forceSync.today,
                    placeholder: "Select a date to sync from"
                  }, null, 8, ["modelValue", "format", "max"])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.forceSync.type == 'custom']
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-danger",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.closeForceSyncModal && _ctx.closeForceSyncModal(...args)))
            }, [
              _cache[33] || (_cache[33] = _createElementVNode("i", { class: "fas fa-times" }, null, -1)),
              _createTextVNode("  " + _toDisplayString(_ctx.$t("close")), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.forceSyncByDate())),
              disabled: _ctx.forceSync.type == 'custom' && !_ctx.forceSync.date,
              type: "button",
              class: "btn btn-sm btn-outline-info"
            }, [...(_cache[34] || (_cache[34] = [
              _createElementVNode("i", { class: "fas fa-save" }, null, -1),
              _createTextVNode("  Request Sync ", -1)
            ]))], 8, _hoisted_52)
          ])
        ])
      ])
    ])
  ], 64))
}